import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssetCardComponent, AssetCardData } from '../asset-card/asset-card.component';
import { CarouselComponent } from '../primeng/carousel/carousel.component';

@Component({
  selector: 'app-similar-datasets',
  standalone: true,
  imports: [CommonModule, AssetCardComponent, CarouselComponent],
  templateUrl: './similar-datasets.component.html',
  styleUrl: './similar-datasets.component.scss'
})
export class SimilarDatasetsComponent {
  @Input() datasets: AssetCardData[] = [];
  @Input() title: string = 'Similar Datasets';
  @Input() assetType: 'dataset' | 'model' | 'usecase' = 'dataset';
  @Input() itemsToShow: number = 3;
  @Input() showDots: boolean = true;
  @Input() showArrows: boolean = true;
  @Input() gap: number = 24;
}

